import { CommonModule } from '@angular/common';
import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';

@Component({
    selector: 'app-v2-add-row',
    standalone: true,
    imports: [CommonModule, FormsModule, AutoCompleteModule, InputTextModule, ButtonModule],
    template: `
        <div class="v2-add-row" [class.v2-add-row--nl]="division === '400'" (keydown)="formKeyDown.emit($event)">
            <div class="v2-field v2-field-line">
                <label>Line</label>
                <input pInputText type="text" class="v2-line-input" [value]="itemForm.lineNumber" disabled />
            </div>

            <div class="v2-field v2-field-item">
                <label>Item</label>
                <p-autoComplete
                    #itemSearchAuto
                    [(ngModel)]="itemForm.FINALRESPNSE"
                    [suggestions]="filteredItemNames"
                    [dropdown]="true"
                    [forceSelection]="true"
                    [delay]="0"
                    [minLength]="3"
                    field="FINALRESPNSE"
                    placeholder="Search item name or number"
                    (onSelect)="onItemSelected($event)"
                    (input)="itemInputChange.emit($event)"
                    (onBlur)="onItemSearchBlur()"
                    (keydown.enter)="onItemSearchEnter($event)"
                ></p-autoComplete>
            </div>

            <div class="v2-field">
                <label>Qty</label>
                <span *ngIf="isCreditNoteOrder" class="v2-credit-note-qty-hint">Enter positive qty; stored as negative</span>
                <input
                    #quantityInput
                    pInputText
                    type="text"
                    inputmode="decimal"
                    autocomplete="off"
                    [(ngModel)]="itemForm.quantity"
                    name="v2quantity"
                    (input)="restrictDecimals.emit({ event: $event, field: 'quantity' })"
                    (focus)="onQuantityFocus($event)"
                    (keydown.enter)="quantityEnter.emit()"
                />
            </div>

            <div class="v2-field">
                <label>Rate</label>
                <input
                    #rateInput
                    pInputText
                    type="text"
                    inputmode="decimal"
                    autocomplete="off"
                    [(ngModel)]="itemForm.rate"
                    name="v2rate"
                    (input)="restrictDecimals.emit({ event: $event, field: 'rate' })"
                    (focus)="onRateFocus($event)"
                    (blur)="rateBlur.emit()"
                    (keydown.enter)="rateEnter.emit()"
                />
            </div>

            <div class="v2-field" *ngIf="division !== '400'">
                <label>Disc %</label>
                <input
                    #discountInput
                    pInputText
                    type="text"
                    inputmode="decimal"
                    autocomplete="off"
                    [(ngModel)]="itemForm.discount"
                    name="v2discount"
                    (input)="restrictDecimals.emit({ event: $event, field: 'discount' })"
                    (focus)="onDiscountFocus($event)"
                    (blur)="discountBlur.emit()"
                    (keydown.enter)="discountEnter.emit()"
                />
            </div>

            <div class="v2-add-btn">
                <button #addBtn type="button" pButton class="v2-add-btn-primary" [disabled]="addDisabled" (click)="addItem.emit()">Add</button>
                <button type="button" pButton class="p-button-secondary" (click)="cancelItem.emit()">Cancel</button>
            </div>
        </div>
    `,
    styles: [
        `
            .v2-credit-note-qty-hint {
                display: block;
                font-size: 0.7rem;
                color: var(--p-text-muted-color, #6b7280);
                margin-bottom: 0.15rem;
                line-height: 1.2;
            }

            .v2-add-row {
                display: grid;
                grid-template-columns:
                    3.4rem
                    minmax(10rem, 2fr)
                    minmax(4rem, 5rem)
                    minmax(5.5rem, 8rem)
                    minmax(3rem, 4rem)
                    auto;
                gap: 0.45rem 0.5rem;
                align-items: end;
                border: 1px solid var(--border-color, var(--p-surface-border));
                border-radius: 0.75rem;
                background: var(--surface-card, var(--p-surface-0));
                padding: 0.75rem;
            }
            .v2-add-row.v2-add-row--nl {
                grid-template-columns:
                    3.4rem
                    minmax(10rem, 2fr)
                    minmax(4rem, 5rem)
                    minmax(5.5rem, 8rem)
                    auto;
            }
            .v2-field {
                display: flex;
                flex-direction: column;
                gap: 0.2rem;
                min-width: 0;
                width: 100%;
            }
            .v2-field ::ng-deep .p-autocomplete,
            .v2-field ::ng-deep .p-autocomplete .p-inputtext,
            .v2-field ::ng-deep .p-autocomplete .p-autocomplete-input {
                width: 100%;
                max-width: 100%;
                box-sizing: border-box;
            }
            .v2-field input.p-inputtext {
                width: 100%;
                box-sizing: border-box;
            }
            .v2-field label {
                font-size: 0.75rem;
                font-weight: 700;
                color: var(--text-secondary, var(--p-text-muted-color));
            }
            .v2-field ::ng-deep .p-autocomplete .p-autocomplete-dropdown {
                min-width: 2.25rem;
            }
            .v2-field ::ng-deep .p-autocomplete .p-autocomplete-input {
                border-radius: var(--p-inputtext-border-radius, 6px);
            }
            .v2-field ::ng-deep .p-autocomplete-panel {
                min-width: 100%;
            }
            .v2-line-input {
                width: 100%;
                min-width: 0;
                text-align: center;
            }
            .v2-add-btn {
                padding-bottom: 0.05rem;
                display: flex;
                gap: 0.4rem;
            }
            .v2-add-btn .p-button {
                min-width: 4.6rem;
            }
            :host ::ng-deep .v2-add-btn .v2-add-btn-primary {
                background: #facc15;
                border-color: #facc15;
                color: #111827;
            }
            :host ::ng-deep .v2-add-btn .v2-add-btn-primary:hover {
                background: #eab308;
                border-color: #eab308;
            }
            .v2-field-item {
                min-width: 0;
                width: 100%;
                max-width: 100%;
            }
            .v2-add-btn {
                white-space: nowrap;
            }
            .v2-add-btn .p-button {
                white-space: nowrap;
            }
            @media (max-width: 1400px) {
                .v2-add-row {
                    grid-template-columns:
                        3rem
                        minmax(8rem, 1.8fr)
                        minmax(3.6rem, 4.5rem)
                        minmax(5rem, 7rem)
                        minmax(2.8rem, 3.6rem)
                        auto;
                    gap: 0.35rem 0.4rem;
                    padding: 0.6rem;
                }
                .v2-add-row.v2-add-row--nl {
                    grid-template-columns:
                        3rem
                        minmax(8rem, 1.8fr)
                        minmax(3.6rem, 4.5rem)
                        minmax(5rem, 7rem)
                        auto;
                }
                .v2-add-btn .p-button {
                    min-width: 3.8rem;
                    padding-left: 0.5rem;
                    padding-right: 0.5rem;
                    font-size: 0.82rem;
                }
            }
            @media (max-width: 1100px) {
                .v2-add-row {
                    grid-template-columns:
                        2.8rem
                        minmax(7rem, 1.6fr)
                        minmax(3.2rem, 4rem)
                        minmax(4.5rem, 6.5rem)
                        minmax(2.6rem, 3.4rem)
                        auto;
                }
                .v2-add-row.v2-add-row--nl {
                    grid-template-columns:
                        2.8rem
                        minmax(7rem, 1.6fr)
                        minmax(3.2rem, 4rem)
                        minmax(4.5rem, 6.5rem)
                        auto;
                }
                .v2-field label {
                    font-size: 0.7rem;
                }
            }
            @media (max-width: 768px) {
                .v2-add-row {
                    grid-template-columns: 1fr;
                    gap: 0.55rem;
                    padding: 0.65rem;
                }
                .v2-field-line,
                .v2-field-item,
                .v2-add-btn {
                    grid-column: span 1;
                }
                .v2-field label {
                    font-size: 0.73rem;
                }
                .v2-add-btn {
                    justify-self: stretch;
                }
                .v2-add-btn .p-button {
                    flex: 1 1 auto;
                }
            }
        `
    ]
})
export class V2AddRowComponent {
    @Input() isCreditNoteOrder = false;
    @Input() itemForm: any;
    @Input() filteredItemNames: any[] = [];
    @Input() division = '';
    @Input() addDisabled = false;
    @Input() errorMessages: { itemName?: string; itemno?: string; quantity?: string; rate?: string; discount?: string } = {};

    @Output() itemSelect = new EventEmitter<any>();
    @Output() itemInputChange = new EventEmitter<any>();
    @Output() restrictDecimals = new EventEmitter<{ event: any; field: 'quantity' | 'rate' | 'discount' }>();
    @Output() quantityEnter = new EventEmitter<void>();
    @Output() rateEnter = new EventEmitter<void>();
    @Output() discountEnter = new EventEmitter<void>();
    @Output() rateBlur = new EventEmitter<void>();
    @Output() discountBlur = new EventEmitter<void>();
    @Output() addItem = new EventEmitter<void>();
    @Output() cancelItem = new EventEmitter<void>();
    @Output() formKeyDown = new EventEmitter<KeyboardEvent>();

    @ViewChild('quantityInput') private quantityInputRef?: ElementRef<HTMLInputElement>;
    @ViewChild('rateInput') private rateInputRef?: ElementRef<HTMLInputElement>;
    @ViewChild('discountInput') private discountInputRef?: ElementRef<HTMLInputElement>;
    @ViewChild('addBtn') private addBtnRef?: ElementRef<HTMLButtonElement>;
    @ViewChild('itemSearchAuto') private itemSearchAutoRef?: any;

    private focusTimerId: ReturnType<typeof setTimeout> | null = null;

    onItemSearchEnter(event: Event): void {
        const keyboardEvent = event as KeyboardEvent;
        keyboardEvent.preventDefault();
        keyboardEvent.stopPropagation();
    }

    focusQuantity(): void {
        this.scheduleFocus('quantity');
    }

    focusRate(): void {
        this.scheduleFocus('rate');
    }

    focusDiscount(): void {
        this.scheduleFocus('discount');
    }

    focusAddButton(): void {
        this.scheduleFocus('add');
    }

    private scheduleFocus(target: 'quantity' | 'rate' | 'discount' | 'add'): void {
        if (this.focusTimerId != null) {
            clearTimeout(this.focusTimerId);
        }
        this.focusTimerId = setTimeout(() => {
            this.focusTimerId = null;
            switch (target) {
                case 'quantity':
                    this.quantityInputRef?.nativeElement?.focus();
                    break;
                case 'rate':
                    this.rateInputRef?.nativeElement?.focus();
                    break;
                case 'discount':
                    this.discountInputRef?.nativeElement?.focus();
                    break;
                case 'add':
                    this.addBtnRef?.nativeElement?.focus();
                    break;
            }
        });
    }

    private cancelScheduledFocus(): void {
        if (this.focusTimerId != null) {
            clearTimeout(this.focusTimerId);
            this.focusTimerId = null;
        }
    }

    focusItemSearch(): void {
        const input = this.itemSearchAutoRef?.inputEL?.nativeElement as HTMLInputElement | undefined;
        if (!input) {
            return;
        }
        if (document.activeElement === input) {
            return;
        }
        input.focus();
        if (!input.value) {
            input.select?.();
        }
    }

    showItemSearchPanel(): void {
        const ac = this.itemSearchAutoRef;
        if (!ac || typeof ac.show !== 'function') {
            return;
        }
        const input = ac.inputEL?.nativeElement as HTMLInputElement | undefined;
        if (document.activeElement !== input) {
            return;
        }
        ac.show();
    }

    setSearchLoading(loading: boolean): void {
        if (this.itemSearchAutoRef) {
            this.itemSearchAutoRef.loading = loading;
        }
    }

    clearSearchLoading(): void {
        setTimeout(() => {
            this.setSearchLoading(false);
        });
    }

    onItemSearchBlur(): void {
        this.clearSearchLoading();
    }

    onItemSelected(event: any): void {
        this.itemSelect.emit(event);
        this.focusQuantity();
    }

    onQuantityFocus(event: FocusEvent): void {
        this.cancelScheduledFocus();
        const input = event.target as HTMLInputElement;
        setTimeout(() => input?.select?.());
    }

    onRateFocus(event: FocusEvent): void {
        this.cancelScheduledFocus();
        const input = event.target as HTMLInputElement;
        setTimeout(() => input?.select?.());
    }

    onDiscountFocus(event: FocusEvent): void {
        this.cancelScheduledFocus();
        const input = event.target as HTMLInputElement;
        setTimeout(() => input?.select?.());
    }
}
